import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import { IconButton, DialogContent, DialogActions } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import CustomConfirmation from "src/components/ModalPopover/Confirmation";
import AddWorkoutCalenderClient from "./AddWorkoutCalenderClient";
import { useEffect } from "react";

export default function EditWorkoutPopupClient({
  open,
  setOpen,
  programme,
  data,
  reloadList,
  member_id,
  member_vdot,
  member_vdot_info,
  day,
  events,
  setEvents,
}) {
  const [openCloseDialog, setOpenCloseDialog] = useState(false);
  const childRef = React.useRef();
  const [modalChangeExe, setModalChangeExe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [questionsToSend, setQuestionsToSend] = useState([]);
  const [editShow, setEditShow] = useState([]);

  const handleParentButtonClick = () => {
    childRef.current.childButtonClickUpdate();
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAgreeDelete = (value) => {
    setOpenCloseDialog(true);
  };

  const handleDelete = async () => {
    handleClose();
    setOpenCloseDialog(false);
  };

  useEffect(() => {
    if (open) {
      setModalChangeExe(false);
      setIsLoading(false);
      const newQuestions = data?.questions || [];
      if (newQuestions && newQuestions.length > 0) {
        setQuestionsToSend(newQuestions);
        setEditShow(newQuestions.map(() => ({ display: false })));
      }
    }
  }, [open]);

  return (
    <div>
      <CustomConfirmation
        openDelete={openCloseDialog}
        setOpenDelete={setOpenCloseDialog}
        title={"Are you sure you want to Close ?"}
        handleAgree={handleDelete}
      />
      <Dialog
        disableEnforceFocus={true}
        open={open}
        fullScreen={true}
        fullWidth
        maxWidth={"lg"}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        id="show-dialog-on-full"
      >
        <div className="text-end mt-2 me-2">
          {modalChangeExe ? (
            <IconButton
              className="back-screen-button"
              onClick={handleAgreeDelete}
            >
              <CloseIcon />
            </IconButton>
          ) : (
            <IconButton className="back-screen-button" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          )}
        </div>

        <DialogContent
          sx={{
            paddingY: 0,
            height: "80vh",
            overflowY: "auto",
          }}
        >
          <AddWorkoutCalenderClient
            setIsLoading={setIsLoading}
            ref={childRef}
            date={data?.workout_date}
            programme={programme}
            member_id={member_id}
            setOpen={setOpen}
            editData={data}
            day={day}
            events={events}
            setEvents={setEvents}
            reloadList={reloadList}
            setModalChangeExe={setModalChangeExe}
            member_vdot={member_vdot}
            member_vdot_info={member_vdot_info}
            questionsToSend={questionsToSend}
            setQuestionsToSend={setQuestionsToSend}
            editShow={editShow}
            setEditShow={setEditShow}
          />
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: "flex-start",
            borderTop: "1px solid rgba(0,0,0,0.12)",
            boxShadow: "0px -1px 4px rgba(0,0,0,0.06)",
            position: "sticky",
            bottom: 0,
            backgroundColor: "background.paper",
            zIndex: 10,
          }}
        >
          {data?.workout_has_logs ? (
            <Button
              disabled={isLoading}
              sx={{ textTransform: "inherit" }}
              onClick={isLoading ? "" : handleParentButtonClick}
              size="small"
              color="primary"
              variant="contained"
              className="small-contained-dialog-button"
            >
              Save
            </Button>
          ) : (
            <>
              {data?.practice_type !== "workbook" ||
              questionsToSend.length > 0 ? (
                <Button
                  disabled={isLoading}
                  sx={{ textTransform: "inherit" }}
                  onClick={isLoading ? "" : handleParentButtonClick}
                  size="small"
                  color="primary"
                  variant="contained"
                  className="small-contained-dialog-button"
                >
                  Save
                </Button>
              ) : (
                ""
              )}
            </>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
